import React from 'react';

const TermsOfService = () => {
  const handleNavigation = (path) => {
    window.location.href = path;
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
      color: 'white',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      {/* Header */}
      <header style={{
        padding: '20px 5%',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <div 
          onClick={() => handleNavigation('/')}
          style={{ cursor: 'pointer', fontSize: '24px', fontWeight: '700' }}
        >
          FreeHappyOne
        </div>
        <button 
          onClick={() => handleNavigation('/login')}
          style={{
            padding: '10px 24px',
            background: 'linear-gradient(135deg, #667eea, #764ba2)',
            border: 'none',
            borderRadius: '20px',
            color: 'white',
            fontWeight: '600',
            cursor: 'pointer'
          }}
        >
          Get Started
        </button>
      </header>

      {/* Content */}
      <main style={{
        maxWidth: '900px',
        margin: '0 auto',
        padding: '60px 5%'
      }}>
        <h1 style={{
          fontSize: 'clamp(32px, 5vw, 48px)',
          fontWeight: '800',
          marginBottom: '16px',
          background: 'linear-gradient(135deg, #667eea, #764ba2)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }}>
          Terms of Service
        </h1>
        
        <p style={{ 
          color: 'rgba(255,255,255,0.6)', 
          marginBottom: '40px',
          fontSize: '16px'
        }}>
          Last Updated: October 4, 2026
        </p>

        {/* Section 1 */}
        <section style={{ marginBottom: '48px' }}>
          <h2 style={{ 
            fontSize: '24px', 
            fontWeight: '700', 
            marginBottom: '20px',
            color: '#667eea'
          }}>
            1. Agreement to Terms
          </h2>
          <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)', marginBottom: '16px' }}>
            Welcome to FreeHappyOne.com ("Platform," "Service," "we," "us," or "our"), operated by <strong>Thornbee LLC</strong>, a North Carolina limited liability company.
          </p>
          <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)', marginBottom: '16px' }}>
            By accessing or using our Platform, you ("User," "you," or "your") agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, you may not access or use the Platform.
          </p>
          <p style={{ 
            lineHeight: '1.8', 
            color: 'rgba(255,255,255,0.85)',
            padding: '16px',
            background: 'rgba(102, 126, 234, 0.1)',
            borderRadius: '12px',
            borderLeft: '4px solid #667eea'
          }}>
            <strong>PLEASE READ THESE TERMS CAREFULLY, INCLUDING THE ARBITRATION AGREEMENT AND CLASS ACTION WAIVER IN SECTION 15.</strong>
          </p>
        </section>

        {/* Section 2 */}
        <section style={{ marginBottom: '48px' }}>
          <h2 style={{ 
            fontSize: '24px', 
            fontWeight: '700', 
            marginBottom: '20px',
            color: '#667eea'
          }}>
            2. Service Description
          </h2>
          <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)', marginBottom: '20px' }}>
            FreeHappyOne.com is an AI-powered personal transformation platform built on the proprietary FHO Framework™ (Free Happy One Operating System). The Platform provides guidance through four integrated AI coaching applications:
          </p>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '16px',
            marginBottom: '24px'
          }}>
            {[
              { name: 'Emit / SAGE', desc: 'Biblical and spiritual wisdom coaching', color: '#4A90E2' },
              { name: 'Family Coach', desc: 'Parenting, grandparenting, and family relationship guidance', color: '#198754' },
              { name: 'SAFE', desc: 'Mental health support and emotional wellness coaching', color: '#dc3545' },
              { name: 'Mental Performance', desc: 'Peak performance and personal excellence coaching', color: '#FFD700' }
            ].map((app, idx) => (
              <div key={idx} style={{
                padding: '20px',
                background: 'rgba(255,255,255,0.05)',
                borderRadius: '12px',
                borderLeft: `4px solid ${app.color}`
              }}>
                <h4 style={{ marginBottom: '8px', color: app.color }}>{app.name}</h4>
                <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.7)', margin: 0 }}>{app.desc}</p>
              </div>
            ))}
          </div>

          <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)' }}>
            The FHO Framework integrates three core transformation processes: <strong>Power</strong> (I-THEE: Connection with the eternal/divine), <strong>Flow</strong> (I-ME: Internal emotional and mental wellness), and <strong>Clarity</strong> (I-WE: Relationships and external connections).
          </p>
        </section>

        {/* Section 3 - Critical Disclaimers */}
        <section style={{ marginBottom: '48px' }}>
          <h2 style={{ 
            fontSize: '24px', 
            fontWeight: '700', 
            marginBottom: '20px',
            color: '#dc3545'
          }}>
            3. Important Disclaimers
          </h2>
          
          <div style={{
            padding: '24px',
            background: 'rgba(220, 53, 69, 0.1)',
            borderRadius: '12px',
            border: '2px solid rgba(220, 53, 69, 0.3)',
            marginBottom: '24px'
          }}>
            <h3 style={{ color: '#dc3545', marginBottom: '16px' }}>
              ⚠️ AI Coaching Is Not Professional Services
            </h3>
            <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)', marginBottom: '16px' }}>
              <strong>CRITICAL NOTICE:</strong> The AI coaches on this Platform are artificial intelligence systems. They are <strong>NOT</strong>:
            </p>
            <ul style={{ 
              lineHeight: '2', 
              color: 'rgba(255,255,255,0.85)',
              paddingLeft: '24px'
            }}>
              <li>Licensed therapists, psychologists, or counselors</li>
              <li>Medical doctors or healthcare providers</li>
              <li>Licensed clinical social workers</li>
              <li>Ordained clergy or pastoral counselors</li>
              <li>Certified financial advisors</li>
              <li>Licensed family therapists</li>
              <li>Certified professional coaches</li>
            </ul>
          </div>

          <div style={{
            padding: '24px',
            background: 'rgba(220, 53, 69, 0.2)',
            borderRadius: '12px',
            border: '2px solid #dc3545',
            marginBottom: '24px'
          }}>
            <h3 style={{ color: '#fff', marginBottom: '16px' }}>
              🚨 Mental Health Crisis Warning
            </h3>
            <p style={{ lineHeight: '1.8', color: 'white', marginBottom: '16px' }}>
              <strong>IF YOU ARE EXPERIENCING A MENTAL HEALTH CRISIS, SUICIDAL THOUGHTS, OR THOUGHTS OF SELF-HARM:</strong>
            </p>
            <ul style={{ 
              lineHeight: '2.2', 
              color: 'white',
              paddingLeft: '24px',
              fontWeight: '600'
            }}>
              <li>Call <strong>988</strong> (Suicide & Crisis Lifeline) immediately</li>
              <li>Call <strong>911</strong> or your local emergency services</li>
              <li>Go to your nearest emergency room</li>
              <li>Text "HELLO" to <strong>741741</strong> (Crisis Text Line)</li>
            </ul>
            <p style={{ lineHeight: '1.8', color: 'white', marginTop: '16px' }}>
              SAFE and other AI coaches on this Platform are NOT equipped to handle mental health emergencies.
            </p>
          </div>

          <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)' }}>
            The guidance provided by our AI coaches is for <strong>informational and educational purposes only</strong> and should never be considered a substitute for professional mental health treatment, medical diagnosis, pastoral counseling, licensed family therapy, or professional coaching services.
          </p>
        </section>

        {/* Section 4 */}
        <section style={{ marginBottom: '48px' }}>
          <h2 style={{ 
            fontSize: '24px', 
            fontWeight: '700', 
            marginBottom: '20px',
            color: '#667eea'
          }}>
            4. Eligibility
          </h2>
          <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)', marginBottom: '16px' }}>
            You must be at least <strong>14 years of age</strong> to use the Platform. If you are between 14 and 17, you may use the Platform only with the permission of a parent or legal guardian, who agrees to these Terms on your behalf. By using the Platform, you represent and warrant that you meet these requirements.
          </p>
          <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)' }}>
            Family Coach may collect information <strong>about</strong> children (such as names and ages) provided by adult users for the purpose of offering parenting guidance. However, children under 14 should not directly use the Platform.
          </p>
        </section>

        {/* Section 5 - Subscription */}
        <section style={{ marginBottom: '48px' }}>
          <h2 style={{ 
            fontSize: '24px', 
            fontWeight: '700', 
            marginBottom: '20px',
            color: '#667eea'
          }}>
            5. Subscription and Billing
          </h2>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '20px',
            marginBottom: '24px'
          }}>
            <div style={{
              padding: '24px',
              background: 'rgba(255,255,255,0.05)',
              borderRadius: '16px',
              textAlign: 'center'
            }}>
              <h4 style={{ color: '#667eea', marginBottom: '8px' }}>Free Trial</h4>
              <p style={{ fontSize: '32px', fontWeight: '800', marginBottom: '8px' }}>$0</p>
              <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.7)' }}>
                7 questions and responses with the FHO Framework
              </p>
            </div>
            <div style={{
              padding: '24px',
              background: 'rgba(102, 126, 234, 0.15)',
              borderRadius: '16px',
              textAlign: 'center',
              border: '2px solid #667eea'
            }}>
              <h4 style={{ color: '#667eea', marginBottom: '8px' }}>Monthly</h4>
              <p style={{ fontSize: '32px', fontWeight: '800', marginBottom: '8px' }}>$39<span style={{ fontSize: '16px', fontWeight: '400' }}>/month</span></p>
              <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.7)' }}>
                Unlimited access to all 4 AI coaches
              </p>
            </div>
            <div style={{
              padding: '24px',
              background: 'rgba(255,255,255,0.05)',
              borderRadius: '16px',
              textAlign: 'center'
            }}>
              <h4 style={{ color: '#198754', marginBottom: '8px' }}>Annual</h4>
              <p style={{ fontSize: '32px', fontWeight: '800', marginBottom: '8px' }}>$360<span style={{ fontSize: '16px', fontWeight: '400' }}>/year</span></p>
              <p style={{ fontSize: '14px', color: '#198754' }}>
                Save $108/year (23% off)
              </p>
            </div>
          </div>

          <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '12px', color: 'white' }}>
            Free Trial Terms
          </h3>
          <ul style={{ 
            lineHeight: '2', 
            color: 'rgba(255,255,255,0.85)',
            paddingLeft: '24px',
            marginBottom: '24px'
          }}>
            <li>The free trial includes <strong>7 questions and responses</strong> with the FHO Framework</li>
            <li>Upon completion of the free trial, your account will automatically convert to a paid monthly subscription at $39/month</li>
            <li>You will be charged automatically unless you cancel before the trial ends</li>
            <li>You may cancel at any time during the trial to avoid charges</li>
            <li>Free trial is limited to one per person/household</li>
          </ul>

          <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '12px', color: 'white' }}>
            Cancellation
          </h3>
          <ul style={{ 
            lineHeight: '2', 
            color: 'rgba(255,255,255,0.85)',
            paddingLeft: '24px'
          }}>
            <li>You may cancel your subscription at any time through your account settings</li>
            <li>Cancellation takes effect at the end of your current billing period</li>
            <li>You will retain access to the Platform until the end of your paid period</li>
            <li>No partial refunds are provided for unused portions of a billing period</li>
          </ul>
        </section>

        {/* Section 6 */}
        <section style={{ marginBottom: '48px' }}>
          <h2 style={{ 
            fontSize: '24px', 
            fontWeight: '700', 
            marginBottom: '20px',
            color: '#667eea'
          }}>
            6. Cross-App Data Sharing and Integration
          </h2>
          <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)', marginBottom: '16px' }}>
            A unique feature of the FreeHappyOne Platform is that our four AI coaches work together to provide holistic guidance. This means information you share with one coach may be accessible to other coaches.
          </p>
          <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)', marginBottom: '16px' }}>
            <strong>By using the Platform, you acknowledge and consent that:</strong>
          </p>
          <ul style={{ 
            lineHeight: '2', 
            color: 'rgba(255,255,255,0.85)',
            paddingLeft: '24px',
            marginBottom: '16px'
          }}>
            <li>Information shared with <strong>Emit / SAGE</strong> (spiritual journey, biblical and Source-aligned questions) may inform guidance from other coaches</li>
            <li>Information shared with <strong>Family Coach</strong> (family structure, parenting challenges) may inform guidance from other coaches</li>
            <li>Information shared with <strong>SAFE</strong> (emotional patterns, mental wellness) may inform guidance from other coaches</li>
            <li>Information shared with <strong>Mental Performance</strong> (goals, performance challenges) may inform guidance from other coaches</li>
          </ul>
          <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)' }}>
            If you do not consent to cross-app data sharing, contact support@freehappyone.com to request data isolation. Some Platform features may be limited without integration.
          </p>
        </section>

        {/* Section 7 */}
        <section style={{ marginBottom: '48px' }}>
          <h2 style={{ 
            fontSize: '24px', 
            fontWeight: '700', 
            marginBottom: '20px',
            color: '#667eea'
          }}>
            7. User Conduct
          </h2>
          <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)', marginBottom: '16px' }}>
            You agree to use the Platform only for lawful purposes. You agree <strong>not</strong> to:
          </p>
          <ul style={{ 
            lineHeight: '2', 
            color: 'rgba(255,255,255,0.85)',
            paddingLeft: '24px'
          }}>
            <li>Use the Platform for mental health emergencies or crisis situations</li>
            <li>Provide false or misleading information about yourself, children, or family members</li>
            <li>Attempt to manipulate AI coaches to generate harmful, illegal, or inappropriate content</li>
            <li>Share your account credentials with others</li>
            <li>Attempt to reverse-engineer, hack, or compromise the Platform</li>
            <li>Reproduce, distribute, or commercialize Platform content without permission</li>
            <li>Violate any applicable local, state, national, or international law</li>
          </ul>
        </section>

        {/* Section 8 */}
        <section style={{ marginBottom: '48px' }}>
          <h2 style={{ 
            fontSize: '24px', 
            fontWeight: '700', 
            marginBottom: '20px',
            color: '#667eea'
          }}>
            8. Intellectual Property
          </h2>
          <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)', marginBottom: '16px' }}>
            The following are proprietary to Thornbee LLC and protected by intellectual property laws:
          </p>
          <ul style={{ 
            lineHeight: '2', 
            color: 'rgba(255,255,255,0.85)',
            paddingLeft: '24px',
            marginBottom: '16px'
          }}>
            <li><strong>FHO Framework™</strong> (Free Happy One Operating System)</li>
            <li><strong>MindStreams™</strong> methodology and concepts</li>
            <li>The concepts of Power, Flow, and Clarity as used in the FHO Framework</li>
            <li>I-THEE, I-ME, and I-WE process designations</li>
            <li>All AI coach names, personalities, and response styles</li>
            <li>Platform design, code, graphics, and user interface</li>
          </ul>
          <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)' }}>
            We grant you a limited, non-exclusive, non-transferable, revocable license to access and use the Platform for personal, non-commercial purposes in accordance with these Terms.
          </p>
        </section>

        {/* Section 9 */}
        <section style={{ marginBottom: '48px' }}>
          <h2 style={{ 
            fontSize: '24px', 
            fontWeight: '700', 
            marginBottom: '20px',
            color: '#667eea'
          }}>
            9. Privacy
          </h2>
          <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)', marginBottom: '16px' }}>
            Your privacy is important to us. Our collection and use of personal information is governed by our <strong>Privacy Policy</strong>, which is incorporated into these Terms by reference.
          </p>
          <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)' }}>
            See our full Privacy Policy at: <a href="/privacy" style={{ color: '#667eea' }}>FreeHappyOne.com/privacy</a>
          </p>
        </section>

        {/* Section 10 */}
        <section style={{ marginBottom: '48px' }}>
          <h2 style={{ 
            fontSize: '24px', 
            fontWeight: '700', 
            marginBottom: '20px',
            color: '#667eea'
          }}>
            10. Disclaimers and Limitation of Liability
          </h2>
          <div style={{
            padding: '24px',
            background: 'rgba(255,255,255,0.05)',
            borderRadius: '12px',
            marginBottom: '20px'
          }}>
            <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)', marginBottom: '16px' }}>
              THE PLATFORM IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED.
            </p>
            <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)' }}>
              TO THE MAXIMUM EXTENT PERMITTED BY LAW: Thornbee LLC shall NOT be liable for any indirect, incidental, special, consequential, or punitive damages, or any damages exceeding the total subscription fees you paid in the <strong>12 months</strong> preceding the claim.
            </p>
          </div>
        </section>

        {/* Section 11-15 */}
        <section style={{ marginBottom: '48px' }}>
          <h2 style={{ 
            fontSize: '24px', 
            fontWeight: '700', 
            marginBottom: '20px',
            color: '#667eea'
          }}>
            11. Indemnification
          </h2>
          <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)' }}>
            You agree to indemnify, defend, and hold harmless Thornbee LLC from any claims, liabilities, damages, or expenses arising from your violation of these Terms, your use of the Platform, or any decision you take based on AI coach guidance.
          </p>
        </section>

        <section style={{ marginBottom: '48px' }}>
          <h2 style={{ 
            fontSize: '24px', 
            fontWeight: '700', 
            marginBottom: '20px',
            color: '#667eea'
          }}>
            12. Modifications to Terms
          </h2>
          <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)' }}>
            We reserve the right to modify these Terms at any time. Material changes will be communicated via email or notice on the Platform. Your continued use after modifications constitutes acceptance of the modified Terms.
          </p>
        </section>

        <section style={{ marginBottom: '48px' }}>
          <h2 style={{ 
            fontSize: '24px', 
            fontWeight: '700', 
            marginBottom: '20px',
            color: '#667eea'
          }}>
            13. Termination
          </h2>
          <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)' }}>
            You may terminate your account at any time by cancelling your subscription or contacting support@freehappyone.com. We may suspend or terminate your account immediately if you breach these Terms or if required by law.
          </p>
        </section>

        <section style={{ marginBottom: '48px' }}>
          <h2 style={{ 
            fontSize: '24px', 
            fontWeight: '700', 
            marginBottom: '20px',
            color: '#667eea'
          }}>
            14. Governing Law and Jurisdiction
          </h2>
          <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)' }}>
            These Terms shall be governed by the laws of the <strong>State of North Carolina</strong>, United States. Any legal action shall be brought exclusively in the federal or state courts located in <strong>Wake County, North Carolina</strong>.
          </p>
        </section>

        <section style={{ marginBottom: '48px' }}>
          <h2 style={{ 
            fontSize: '24px', 
            fontWeight: '700', 
            marginBottom: '20px',
            color: '#667eea'
          }}>
            15. Dispute Resolution and Arbitration
          </h2>
          <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)', marginBottom: '16px' }}>
            Before filing any formal dispute, you agree to contact us at support@freehappyone.com and attempt to resolve the dispute informally for at least 30 days.
          </p>
          <div style={{
            padding: '24px',
            background: 'rgba(255, 215, 0, 0.1)',
            borderRadius: '12px',
            border: '2px solid rgba(255, 215, 0, 0.3)'
          }}>
            <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)', marginBottom: '16px' }}>
              <strong>BINDING ARBITRATION:</strong> If we cannot resolve the dispute informally, you and Thornbee LLC agree to resolve any dispute through binding individual arbitration rather than in court.
            </p>
            <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)' }}>
              <strong>CLASS ACTION WAIVER:</strong> YOU AND MINDSTREAMS TECHNOLOGY LLC AGREE THAT EACH MAY BRING CLAIMS AGAINST THE OTHER ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE PROCEEDING.
            </p>
          </div>
        </section>

        {/* Contact Section */}
        <section style={{ marginBottom: '48px' }}>
          <h2 style={{ 
            fontSize: '24px', 
            fontWeight: '700', 
            marginBottom: '20px',
            color: '#667eea'
          }}>
            16. Contact Information
          </h2>
          <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.85)', marginBottom: '20px' }}>
            For questions about these Terms of Service, please contact:
          </p>
          <div style={{
            padding: '24px',
            background: 'rgba(255,255,255,0.05)',
            borderRadius: '12px'
          }}>
            <p style={{ marginBottom: '12px', color: 'white' }}><strong>Thornbee LLC</strong></p>
            <p style={{ marginBottom: '16px', color: 'rgba(255,255,255,0.85)' }}>
              Email: <a href="mailto:support@freehappyone.com" style={{ color: '#667eea' }}>support@freehappyone.com</a>
            </p>
            <p style={{ marginBottom: '8px', color: 'rgba(255,255,255,0.7)', fontSize: '14px' }}>
              <strong>Mailing Address:</strong>
            </p>
            <p style={{ color: 'rgba(255,255,255,0.85)', lineHeight: '1.6' }}>
              Thornbee LLC<br />
              1001 Wade Ave Suite 327<br />
              Raleigh, NC 27605<br />
              United States
            </p>
          </div>
        </section>

        {/* Acknowledgment */}
        <section style={{
          padding: '32px',
          background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.15), rgba(118, 75, 162, 0.15))',
          borderRadius: '16px',
          border: '2px solid rgba(102, 126, 234, 0.3)',
          marginBottom: '48px'
        }}>
          <h2 style={{ 
            fontSize: '24px', 
            fontWeight: '700', 
            marginBottom: '20px',
            color: 'white'
          }}>
            Acknowledgment
          </h2>
          <p style={{ lineHeight: '1.8', color: 'rgba(255,255,255,0.9)' }}>
            BY USING THE FREEHAPPYONE PLATFORM, YOU ACKNOWLEDGE THAT: You have read and understand these Terms of Service; You are at least 14 years of age, and if you are under 18, you have the permission of a parent or legal guardian; You understand that AI coaches are not licensed professionals; You will seek professional help for serious mental health, medical, or legal matters; You consent to cross-app data sharing as described herein; You agree to the arbitration agreement and class action waiver; You agree to be bound by these Terms.
          </p>
        </section>

        {/* Footer */}
        <div style={{ 
          textAlign: 'center', 
          color: 'rgba(255,255,255,0.5)',
          fontSize: '14px',
          paddingTop: '32px',
          borderTop: '1px solid rgba(255,255,255,0.1)'
        }}>
          <p>© 2026 Thornbee LLC. All rights reserved.</p>
          <p style={{ marginTop: '8px' }}>FHO Framework™ is a trademark of Thornbee LLC.</p>
        </div>
      </main>
    </div>
  );
};

export default TermsOfService;
